module.exports = __webpack_public_path__ + "img/lul_yes.6195550b.png";